import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { DashboardHeader } from "@/components/dashboard";
import { AdminSidebar } from "@/components/admin/admin-sidebar";
import { GlobalLoader } from "@/components/ui/global-loader";

export const Route = createFileRoute("/dashboard/admin")({
  beforeLoad: async ({ context }) => {
    const { session } = context;
    if (!session?.user?.isAdmin) {
      throw redirect({ to: "/dashboard" });
    }
  },
  pendingComponent: AdminPending,
  component: AdminLayout,
});

function AdminShell({ children }: { children: React.ReactNode }) {
  return (
    <>
      <DashboardHeader />
      <div className="mx-auto max-w-6xl space-y-4 px-4 py-6 md:flex md:gap-6 md:space-y-0 md:px-6 md:py-8">
        <AdminSidebar />
        <main className="min-w-0 flex-1">{children}</main>
      </div>
    </>
  );
}

function AdminLayout() {
  return (
    <AdminShell>
      <Outlet />
    </AdminShell>
  );
}

function AdminPending() {
  return (
    <AdminShell>
      <GlobalLoader />
    </AdminShell>
  );
}
